import { render, staticRenderFns } from "./DefaultIconLetter.vue?vue&type=template&id=a6fb670e&scoped=true&"
import script from "./DefaultIconLetter.vue?vue&type=script&lang=js&"
export * from "./DefaultIconLetter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultIconLetter.vue?vue&type=style&index=0&id=a6fb670e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fb670e",
  null
  
)

export default component.exports